const initialState = {
  rfInstance: null,
  globalParameters: {},
  nodes: [],
  edges: [],
  mouseOverPane: false,
  editionInProgress: false,
  app: null,
  brand: null,
  name: null,
  version: null,
  flowLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "update-viewport":
      return {
        ...state,
        viewport: action.viewport,
      };

    case "update-rf-instance":
      return {
        ...state,
        rfInstance: action.rfInstance,
      };

    case "clear-flow":
      return {
        ...initialState,
        rfInstance: state.rfInstance,
      };

    // Flow other data: _id, name, brand, ...etc
    /*case 'update-flow-data':
            return {
                ...state,
                ...action.data
            }*/
    case "update-flow":
      return {
        ...state,
        ...action.flow,
        flowLoaded: true,
      };
    case "update-flow-data":
      return {
        ...state,
        [action.key]: action.value,
      };
    case "update-flow-app":
      return {
        ...state,
        app: action.app,
      };
    case "update-flow-brand":
      return {
        ...state,
        brand: action.brand,
      };
    case "update-flow-name":
      return {
        ...state,
        name: action.name,
      };
    case "update-flow-version":
      return {
        ...state,
        version: action.version,
      };

    case "update-global-parameters":
      return {
        ...state,
        globalParameters: action.globalParameters,
      };

    // NODES
    case "set-start-node":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          return {
            ...node,
            data: {
              ...node.data,
              starter: node.id === action.id,
            },
          };
        }),
      };
    case "set-selected-node":
      return {
        ...state,
        //selectedNode: action.value
        nodes: state.nodes.map((node) => {
          if (node.id === action.node.id) {
            return {
              ...node,
              selected: true,
            };
          } else {
            return {
              ...node,
              selected: false,
            };
          }
        }),
      };
    /*case 'add-node':
            return {
                ...state,
                nodes: [...state.nodes, action.value]
            }*/
    case "select-all-nodes": {
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          return {
            ...node,
            selected: true,
          };
        }),
      };
    }
    case "unselect-all-nodes":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          return {
            ...node,
            selected: false,
          };
        }),
      };
    case "update-node-list":
      return {
        ...state,
        nodes: action.value,
      };
    case "update-node-position":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.value.id) {
            return {
              ...node,
              position: action.value.position,
              zIndex: 1000,
            };
          } else {
            return {
              ...node,
              zIndex:
                node.zIndex !== undefined
                  ? node.zIndex - 1 > 0
                    ? node.zIndex - 1
                    : 0
                  : 0,
            };
          }
        }),
      };
    case "update-node-data":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.id) {
            return {
              ...node,
              data: action.data,
            };
          } else {
            return node;
          }
        }),
      };
    case "update-node-parameters":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.id) {
            return {
              ...node,
              data: {
                ...node.data,
                module: {
                  ...node.data.module,
                  parameters: node.data.module.parameters
                    ? {
                        ...node.data.module.parameters,
                        ...action.parameters,
                      }
                    : action.parameters,
                },
              },
            };
          } else {
            return node;
          }
        }),
      };
    case "update-node-options":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.id) {
            if (node.data.module.options.type !== action.options.type) {
              return {
                ...node,
                data: {
                  ...node.data,
                  module: {
                    ...node.data.module,
                    options: {
                      type: action.options.type,
                    },
                    parameters: {},
                  },
                },
              };

              /*return {
                                ...node,
                                data: {
                                    ...node.data,
                                    module: {
                                        ...node.data.module,
                                        options: node.data.module.options? {
                                            ...node.data.module.options,
                                            ...action.options
                                        }: action.options
                                    }

                                }
                            }*/
            } else {
              return {
                ...node,
                data: {
                  ...node.data,
                  module: {
                    ...node.data.module,
                    options: {
                      ...node.data.module.options,
                      ...action.options,
                    },
                  },
                },
              };
            }
          } else {
            return node;
          }
        }),
      };
    case "update-node-name":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.id) {
            return {
              ...node,
              data: {
                ...node.data,
                name: action.name,
              },
            };
          } else {
            return node;
          }
        }),
      };
    case "order-next-node-list-conditions":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.nodeId) {
            return {
              ...node,
              nextNodeListConditions: action.list,
            };
          } else {
            return node;
          }
        }),
      };
    case "add-to-next-condition-list":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.nodeId) {
            return {
              ...node,
              nextNodeListConditions: [
                ...node.nextNodeListConditions,
                action.edgeId,
              ],
            };
          } else {
            return node;
          }
        }),
      };
    case "remove-next-condition-from-list":
      return {
        ...state,
        nodes: state.nodes.map((node) => {
          if (node.id === action.nodeId) {
            return {
              ...node,
              nextNodeListConditions: node.nextNodeListConditions.filter(
                (edgeId) => edgeId !== action.edgeId
              ),
            };
          } else {
            return node;
          }
        }),
      };

    // EDGES
    case "update-edge-list":
      return {
        ...state,
        edges: action.value,
      };
    case "select-all-edges": {
      return {
        ...state,
        edges: state.edges.map((edge) => {
          return {
            ...edge,
            selected: true,
            animated: true,
          };
        }),
      };
    }
    case "unselect-all-edges":
      return {
        ...state,
        edges: state.edges.map((edge) => {
          return {
            ...edge,
            selected: false,
            animated: false,
          };
        }),
      };
    case "set-selected-edge":
      return {
        ...state,
        //selectedEdge: action.value,
        edges: state.edges.map((edge) => {
          if (edge.id === action.id) {
            return {
              ...edge,
              selected: true,
              animated: true,
            };
          } else {
            return {
              ...edge,
              animated: false,
            };
          }
        }),
      };
    case "update-edge-data":
      return {
        ...state,
        edges: state.edges.map((edge) => {
          if (edge.id === action.value.id) {
            return action.value;
          } else {
            return edge;
          }
        }),
      };
    case "update-edge-connection":
      return {
        ...state,
        edges: state.edges.map((edge) => {
          if (edge.id === action.id) {
            return action.value;
          } else {
            return edge;
          }
        }),
      };
    case "enable-edition-in-progress":
      return {
        ...state,
        editionInProgress: true,
      };
    case "disable-edition-in-progress":
      return {
        ...state,
        editionInProgress: false,
      };
    /*case 'mouse-over-pane':
            return {
                ...state,
                mouseOverPane: true
            }
        case 'mouse-outside-pane': {
            return {
                ...state,
                mouseOverPane: false
            }
        }*/
    default:
      return initialState;
  }
};

export { reducer, initialState };
